import $ from 'jquery';
import BaseClass from '../base/BaseClass';
import Util from '../util/Util';

/**
 * svg SP<->PC 切り替えクラス
 * @example
 * //divの中身にsvgファイルの中身が出力されます
 * <div class="js-svgChange" data-src="./img/test.svg"></div>
 *      pc->./img/test.svg
 *      sp->./img/sp/test.svg
 *
 * //PCとSPでファイル名が違う場合
 * <div class="js-svgChange" data-src="./img/test.svg" data-src_sp="./img/sp/test.svg"></div>
 *
 */
export default class SvgChangeClass extends BaseClass {
  constructor() {
    super();
    this.name = 'SvgChangeClass';

    this.EVENT_LOADEND = 'eventLoadend';
    this.spSize = Util.BREAK_POINT;
    this.target;
    this.windowSize;

    this.items;
    this.nMax = 0;
    this.count = 0;
    this.imgObj = [];
  }

  /**
     * 生成開始時
     * @param {String} _target 対象となるクラス名やid名 デフォルトbody
     */
  onCreate(_target) {
    super.onCreate();
    this.target = (_target) ? _target : $('body');
  }

  onLoad() {
    super.onLoad();
    this.items = $('.js-svgChange', this.target);
    if (this.items.length === 0) { this.jq.trigger(this.EVENT_LOADEND); }
    this.onChangeBreakPoint();
  }

  onChangeBreakPoint(_b) {
    if (!this.items) { return; }

    let windowWidth = this.windowSize.w;
    this.count = 0;
    this.nMax = 0;

    let self = this;
    this.items.each((index, element) => {
      let _this = $(element);
      let src = _this.attr('data-src');
      let cl = _this.attr('class');
      _this.empty();
      if (!src) { return true; }
      let cSrc = null;
      if (cl.indexOf('both') !== -1) {
        cSrc = src;
      } else if (windowWidth <= self.spSize && cl.indexOf('onlyPc') === -1) {
        let spsrc = _this.attr('data-src_sp');
        cSrc = (spsrc) ? spsrc : Util.getSpImagePath(src);
      } else if (windowWidth > self.spSize && cl.indexOf('onlySp') === -1) {
        cSrc = src;
      }

      if (!cSrc) { return true; }
      self.nMax++;

      _this.load(cSrc, () => {
        self.count++;
        _this.css({ visibility: 'visible' });
        if (self.count >= self.nMax) {
          self.jq.trigger(self.EVENT_LOADEND);
        }
      });
    });

    if (self.nMax === 0) {
      self.jq.trigger(self.EVENT_LOADEND);
    }
  }

  onResize(size) {
    this.windowSize = size;
  }
}
